import { render, staticRenderFns } from "./InsuranceProposal.vue?vue&type=template&id=bc5c0430&"
import script from "./InsuranceProposal.vue?vue&type=script&lang=js&"
export * from "./InsuranceProposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports